import { render, staticRenderFns } from "./comMap.vue?vue&type=template&id=4071050e&scoped=true&"
import script from "./comMap.vue?vue&type=script&lang=js&"
export * from "./comMap.vue?vue&type=script&lang=js&"
import style0 from "./comMap.vue?vue&type=style&index=0&id=4071050e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071050e",
  null
  
)

export default component.exports